import { render, staticRenderFns } from "./Arrange.vue?vue&type=template&id=4a40c972&"
import script from "./Arrange.vue?vue&type=script&lang=js&"
export * from "./Arrange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports